import { render } from "./DeleteVeteranDialog.vue?vue&type=template&id=4ee59df3"
import script from "./DeleteVeteranDialog.vue?vue&type=script&lang=js"
export * from "./DeleteVeteranDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__